import React, { useEffect } from 'react';
import { SelectionStyle, SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, element, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { classNames, enumValues, getLostProps, propagateProps } from '@philips-internal/oswald-ui-utils';
import { Checkbox } from '../../checkbox/checkbox.js';
import { RadioButton } from '../../radio-group/radio-button.js';
import { CardContainerSuperscription } from '../components/card-container-superscription.js';
import { useCardContainer } from '../context/card-container-context.js';
import { CardContainerHeaderAPI } from './card-container-header-api.js';
import './card-container-header.css';
const HeaderContainer = {
    name: '',
};
function HeaderSelection(props) {
    if (!props.selectable || props.selectionType === SelectionType.NONE) {
        return null;
    }
    if (props.selectionType === SelectionType.MULTIPLE) {
        return (React.createElement(Checkbox, { className: "c-card-container-header__checkbox", name: "c-card-container-header-checkbox", onChange: props.onSelectionInputChange, uuid: "c-card-container-header-checkbox", value: Boolean(props.selected) }));
    }
    if (props.selectionType === SelectionType.SINGLE && props.selectionStyle === SelectionStyle.RADIO) {
        return (React.createElement(RadioButton, { checked: Boolean(props.selected), className: "c-card-container-header__radio-button", label: "", name: "c-card-container-header-radio-button", onChange: props.onSelectionInputChange, uuid: "c-card-container-header-radio-button", value: "" }));
    }
    return null;
}
function CardContainerHeader(props) {
    const context = useCardContainer();
    useEffect(() => {
        const unregister = context.registerHeader();
        return () => {
            unregister();
        };
    }, []);
    const className = classNames({
        'c-card-container-header': true,
        'c-card-container-header--highlighted': Boolean(props.highlighted),
    });
    const lostProps = getLostProps(CardContainerHeader.propTypes, props);
    return (React.createElement(Container, { className: className, uuid: props.uuid },
        context.hasBody ? null : (React.createElement(CardContainerSuperscription, { ...lostProps })),
        propagateProps(props.children, { ...lostProps }),
        React.createElement(HeaderSelection, { onSelectionInputChange: props.onSelectionInputChange, selectable: props.selectable, selected: props.selected, selectionStyle: props.selectionStyle, selectionType: props.selectionType })));
}
CardContainerHeader.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    highlighted: bool,
    selectable: bool.notEnumerable(),
    selected: bool.notEnumerable(),
    selectionType: oneOf(enumValues(SelectionType)).notEnumerable(),
    uuid: string,
};
CardContainerHeader.defaultProps = {
    uuid: '',
};
const awesomeProps = {
    api: CardContainerHeaderAPI,
    containers: [HeaderContainer],
    type: ComponentType.LAYOUT,
};
AwesomeComponent(awesomeProps)(CardContainerHeader);
export { CardContainerHeader, };
//# sourceMappingURL=card-container-header.js.map